import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { MasterService } from '../../../../master/services/master.service';
import { Option } from '../../../../../shared/models/option.model';

@Injectable({ providedIn: 'root' })
export class PaymentCardFormLookupsFacade {
  constructor(private masterService: MasterService) { }

  bankAccounts(): Promise<Option[]> {
    return firstValueFrom(this.masterService.getBankAccounts()).then(list => (list || [])
      .filter(account => !!account && !!account.id)
      .map(account => {
        const bank = account.metadata && account.metadata.bank ? String(account.metadata.bank) : '';
        const iban = account.display ? String(account.display) : '';
        return { id: String(account.id), display: [bank, iban].filter(Boolean).join(' · ') || String(account.id) };
      }));
  }
}
